import React from "react";
import styles from './styles.module.scss'
import {Workbook} from "../../types/Storyboard";
import {Link} from "react-router-dom";
import {setWorkbook} from "../../containers/Storyboard/storyboardSlice";
import {useAppDispatch} from "../../hooks";
import {Routes} from "../../pages/routes";
import classNames from "classnames";

export type StoryboardPreviewProps = {
    workbook: Workbook
    isWithinDrawer?: boolean
    selected?: boolean
}

export const StoryboardPreview = ({workbook, isWithinDrawer = false, selected = false}: StoryboardPreviewProps) => {

    const truncateName = (name: string, max = 35) =>
        name.length > max ? name.slice(0, max) + "..." : name

    const dispatch = useAppDispatch()

    return <div data-testid={workbook.workbookId} key={workbook.workbookId} className={styles.storyboardPreviewImage}>
        <Link
            to={`${Routes.Storyboard}/${workbook.workbookId}`}
            className={classNames({[styles.active]: selected}, {[styles.withinDrawer]: isWithinDrawer})}
            onClick={() => dispatch(setWorkbook(workbook))}>
            <img src={`data:image/png;base64, ${workbook.previewImage}`} alt={workbook.name}/>
            <span className={styles.nameWrapper}>
                {truncateName(workbook.name)}
                <span className={styles.fullName}>{workbook.name}</span>
            </span>
        </Link>
    </div>
}
